import Compressor from 'compressorjs'

export const imageFileToBase64 = async (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = reject
  })
}

export const getImageData = async (url) => {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => {
      resolve({
        img,
        width: img.width,
        height: img.height
      })
    }
    img.src = url
    img.onerror = reject
  })
}
export const qualityFile = async (file) => {
  return new Promise((resolve) => {
    // eslint-disable-next-line no-new
    new Compressor(file, {
      mimeType: 'image/jpeg',
      quality: 0.6,
      success (res) {
        const newFile = new File([res], file.name, {
          type: file.type
        })
        resolve(newFile)
      },
      error (e) {
        resolve(file)
      }
    })
  })
}
